import { observer } from 'mobx-react-lite'
import { useId, type ReactNode } from 'react'
import { Card, CardContent } from '@/components/Card'
import { ExpandableCardList } from '@/components/ExpandableCardList'
import { SectionHeadline } from '@/components/SectionHeadline'
import { InvalidFieldsSubtitle } from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InvalidFieldsSubtitle'
import styles from './StepCardListContainer.module.css'
import { SkeletonAccordionList } from '../SkeletonAccordionList'

interface StepCardListContainerProps {
  title: ReactNode
  actions: ReactNode
  hasError: boolean
  renderEmptyState?: () => ReactNode
  children: ReactNode
  isSkeleton?: boolean
  testId?: string
}

export const StepCardListContainer = observer(function StepCardListContainer({
  title,
  actions,
  hasError,
  renderEmptyState,
  children,
  isSkeleton,
  testId,
}: StepCardListContainerProps) {
  const headlineId = useId()

  return (
    <Card>
      <CardContent>
        <StepCardListContainerContent>
          <SectionHeadline
            id={headlineId}
            stackWhenCompact
            action={actions}
            isSkeleton={isSkeleton}
            testId={testId ? `${testId}-headline` : undefined}
          >
            {title}
            <InvalidFieldsSubtitle hasError={hasError} />
          </SectionHeadline>
          <ExpandableCardList
            aria-labelledby={headlineId}
            renderEmptyState={renderEmptyState}
          >
            {!isSkeleton ? children : <SkeletonAccordionList count={3} />}
          </ExpandableCardList>
        </StepCardListContainerContent>
      </CardContent>
    </Card>
  )
})

export function StepCardListContainerContent({ children }: { children: ReactNode }) {
  return (
    <div className={styles.stepRoot}>{children}</div>
  )
}
